import { connect } from 'react-redux';
import Plan from './Plan';

const mapStateToProps = state => ({
  user: state.user,
});

export default connect(mapStateToProps)(Plan);
